export default "__VITE_PUBLIC_ASSET__e6a236f3__"